import React from 'react';

interface HeadingProps {
  children: React.ReactNode;
  className?: string;
  level?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
}

export default function Heading({ children, className = '', level = 'h2' }: HeadingProps) {
  const Tag = level as keyof JSX.IntrinsicElements;
  return <Tag className={`sm:text-2xl text-xl font-semibold font-lato ${className}`}>{children}</Tag>;
}
